import moment from 'moment-timezone';
import Moment from 'react-moment';
import {http} from '~/services/http';
import {SET_CURRENT_LANGUAGE, LOAD_LANGUAGES, LOAD_TRANSLATIONS} from './types';

export const setCurrentLanguage = (lang) => (dispatch) => {
    // Update moment locale instances
    moment.locale(lang.code);
    Moment.globalLocale = lang.code;
    moment();

    dispatch({
        type: SET_CURRENT_LANGUAGE,
        payload: lang
    })
}

export const loadLanguagesAction = () => async (dispatch) => {

    const response = await http.get('/languages');

    dispatch({
        type: LOAD_LANGUAGES,
        payload: response?.data || []
    });
};

export const loadTranslationsAction = () => async (dispatch) => {

    const response = await http.get('/translations');

    dispatch({
        type: LOAD_TRANSLATIONS,
        payload: response?.data || {}
    });
};
